import React from 'react';
import {UploadImage} from 'components/UI/Image';
import {Link} from 'react-router-dom';

class ArticleItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className='item-support-container'>
        <div className='wrap-image-support-container'>
          <a className='img-link'>
            <UploadImage transform="crop" className='item-image' width="60" height="60" type="ARTICLE" image={this.props.item.image}/>
          </a>
        </div>
        <h3 className='title-black'>{this.props.item.title}</h3>
        <p className='support-container-description'>{this.props.item.description}</p>
        <p className='support-container-link'><Link to={`cms/${this.props.item.slug}`} className='view-more'>Xem chi tiết</Link></p>
      </div>
    );
  }
}

export default ArticleItem;



// WEBPACK FOOTER //
// ./components/home/sub-view/Article/ArticleItem.jsx